import { render, staticRenderFns } from "./ChatInputWrap.vue?vue&type=template&id=8a6a27ea&scoped=true&"
import script from "./ChatInputWrap.vue?vue&type=script&lang=js&"
export * from "./ChatInputWrap.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputWrap.vue?vue&type=style&index=0&id=8a6a27ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6a27ea",
  null
  
)

export default component.exports